import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IDevice } from 'app/shared/model/device.model';
import { getEntities as getDevices } from 'app/entities/device/device.reducer';
import { IDeviceReportedMetric } from 'app/shared/model/device-reported-metric.model';
import { getEntity, updateEntity, createEntity, reset } from './device-reported-metric.reducer';

export const DeviceReportedMetricUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const devices = useAppSelector(state => state.device.entities);
  const deviceReportedMetricEntity = useAppSelector(state => state.deviceReportedMetric.entity);
  const loading = useAppSelector(state => state.deviceReportedMetric.loading);
  const updating = useAppSelector(state => state.deviceReportedMetric.updating);
  const updateSuccess = useAppSelector(state => state.deviceReportedMetric.updateSuccess);

  const handleClose = () => {
    navigate('/device-reported-metric' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDevices({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  // eslint-disable-next-line complexity
  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    values.deviceReportedTime = convertDateTimeToServer(values.deviceReportedTime);

    const entity = {
      ...deviceReportedMetricEntity,
      ...values,
      device: devices.find(it => it.id.toString() === values.device.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          deviceReportedTime: displayDefaultDateTime(),
        }
      : {
          ...deviceReportedMetricEntity,
          deviceReportedTime: convertDateTimeFromServer(deviceReportedMetricEntity.deviceReportedTime),
          device: deviceReportedMetricEntity?.device?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="rainspotApp.deviceReportedMetric.home.createOrEditLabel" data-cy="DeviceReportedMetricCreateUpdateHeading">
            <Translate contentKey="rainspotApp.deviceReportedMetric.home.createOrEditLabel">
              Create or edit a DeviceReportedMetric
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="device-reported-metric-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('rainspotApp.deviceReportedMetric.attribute')}
                id="device-reported-metric-attribute"
                name="attribute"
                data-cy="attribute"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('rainspotApp.deviceReportedMetric.value')}
                id="device-reported-metric-value"
                name="value"
                data-cy="value"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('rainspotApp.deviceReportedMetric.deviceReportedTime')}
                id="device-reported-metric-deviceReportedTime"
                name="deviceReportedTime"
                data-cy="deviceReportedTime"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                id="device-reported-metric-device"
                name="device"
                data-cy="device"
                label={translate('rainspotApp.deviceReportedMetric.device')}
                type="select"
              >
                <option value="" key="0" />
                {devices
                  ? devices.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/device-reported-metric" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DeviceReportedMetricUpdate;
